import { Controller } from "@hotwired/stimulus"

// Removes a secret shown once as soon as the page is hidden, so the browser's
// back-forward cache can never show it again.
//
//   <section data-controller="secret" data-action="pagehide@window->secret#forget">...</section>
export default class extends Controller {
  forget() {
    this.element.remove()
  }
}
